import { Box, Button, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useDataDocumentItems from '../../hooks/useDataDocumentItems';
import { OrderStatus } from '../../enums/orderStatus';
import { DocumentService } from '../../services/document.service';
import ModalWrapper from '../Modals/ModalWrapper';
import { useNotify } from '../../provider/NotifyProvider';
import { useAuth } from '../../store/auth.store';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { useDocuments } from '../../store/documents.store';
import { useCart } from '../../store/cart.store';


const MySvgIcon1 = () => {
    return (
        <svg
        width="25"
        height="26"
        viewBox="0 0 25 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
            d="M6.00014 16H19.1359C20.1487 16 20.6551 16 21.0582 15.8112C21.4134 15.6448 21.7118 15.3777 21.9163 15.0432C22.1485 14.6633 22.2044 14.16 22.3163 13.1534L22.9013 7.88835C22.9355 7.58088 22.9525 7.42715 22.9031 7.30816C22.8597 7.20366 22.7821 7.11697 22.683 7.06228C22.5702 7 22.4155 7 22.1062 7H5.50014M3 4H4.24844C4.51306 4 4.64537 4 4.74889 4.05032C4.84002 4.09463 4.91554 4.16557 4.96544 4.25376C5.02212 4.35394 5.03037 4.48599 5.04688 4.7501L5.95312 19.2499C5.96963 19.514 5.97788 19.6461 6.03456 19.7462C6.08446 19.8344 6.15998 19.9054 6.25111 19.9497C6.35463 20 6.48694 20 6.75156 20H20M8.5 23.5H8.51M17.5 23.5H17.51M9 23.5C9 23.7761 8.77614 24 8.5 24C8.22386 24 8 23.7761 8 23.5C8 23.2239 8.22386 23 8.5 23C8.77614 23 9 23.2239 9 23.5ZM18 23.5C18 23.7761 17.7761 24 17.5 24C17.2239 24 17 23.7761 17 23.5C17 23.2239 17.2239 23 17.5 23C17.7761 23 18 23.2239 18 23.5Z"
            stroke="#FF32BB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
            stroke: "#FF32BB",
            strokeOpacity: 1
            }}
        />
        <path
            d="M3 21L21.5 3"
            stroke="white"
            strokeWidth="6"
            strokeLinecap="round"
            style={{
            stroke: "white",
            strokeOpacity: 1
            }}
        />
        <path
            d="M2.5 21L21 3"
            stroke="#FF32BB"
            strokeWidth="2"
            strokeLinecap="round"
            style={{
            stroke: "#FF32BB",
            strokeOpacity: 1
            }}
        />
        </svg>
    )
}

const MySvgIcon2 = () => (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00014 16.5H19.1359C20.1487 16.5 20.6551 16.5 21.0582 16.3112C21.4134 16.1448 21.7118 15.8777 21.9163 15.5432C22.1485 15.1633 22.2044 14.66 22.3163 13.6534L22.9013 8.38835C22.9355 8.08088 22.9525 7.92715 22.9031 7.80816C22.8597 7.70366 22.7821 7.61697 22.683 7.56228C22.5702 7.5 22.4155 7.5 22.1062 7.5H5.50014M3 4.5H4.24844C4.51306 4.5 4.64537 4.5 4.74889 4.55032C4.84002 4.59463 4.91554 4.66557 4.96544 4.75376C5.02212 4.85394 5.03037 4.98599 5.04688 5.2501L5.95312 19.7499C5.96963 20.014 5.97788 20.1461 6.03456 20.2462C6.08446 20.3344 6.15998 20.4054 6.25111 20.4497C6.35463 20.5 6.48694 20.5 6.75156 20.5H20M8.5 24H8.51M17.5 24H17.51M9 24C9 24.2761 8.77614 24.5 8.5 24.5C8.22386 24.5 8 24.2761 8 24C8 23.7239 8.22386 23.5 8.5 23.5C8.77614 23.5 9 23.7239 9 24ZM18 24C18 24.2761 17.7761 24.5 17.5 24.5C17.2239 24.5 17 24.2761 17 24C17 23.7239 17.2239 23.5 17.5 23.5C17.7761 23.5 18 23.7239 18 24Z"
        stroke="white"
        style={{ stroke: "white", strokeOpacity: 1 }}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 21.5L21.5 3.5"
        stroke="#8EA6B2"
        style={{
          stroke: "#8EA6B2",
          strokeOpacity: 1,
        }}
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M2.5 21.5L21 3.5"
        stroke="white"
        style={{ stroke: "white", strokeOpacity: 1 }}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
  
const Options = () => {
    const {id} = useParams()
    const {data,mutate,isLoading} = useDataDocumentItems(id!)
    const isCanEdit = data?.status === OrderStatus.Online || OrderStatus.AvailableForAssignment === data?.status;
    const [openModal, setOpenModal] = useState(false)
    const {openEdit,setOpenEdit, setChoosedDocument, setLoading, loading} = useDocuments()
    const [deliveryDate, setDeliveryDate] = useState(new Date())
    const [text, setText] = useState('')
    const {onErrorNotify, onSuccessNotify} = useNotify()
    const { user } = useAuth()
    const {clearCart,setCart, cart, comment, setComment} = useCart()

    const handleDelete = () => {
        if(!user?.permission?.permissionDetaileds[0]?.isOrderEditable) {
            onErrorNotify('אין הרשאה לערוך הזמנה או לבטל הזמנה') 
            return 
        }
        try {
            setLoading(true)
            DocumentService.updateOrder(id!,true,data?.deliveryDate!, data?.comment + ' ' + text).then((e) => {
                if(e.status === 'success'){
                    onSuccessNotify(e.message)
                } else {
                    onErrorNotify(e.message)
                }
                mutate().then(() => {
                    setLoading(false)
                })
            })

        } catch(e) {

        } finally {
            setOpenModal(false)
        }
    }

    const handleEdit = () => {
        if(!user?.permission?.permissionDetaileds[0]?.isOrderEditable) {
            onErrorNotify('אין הרשאה לערוך הזמנה או לבטל הזמנה') 
            return 
        }
        closeEdit()
        try {
            setLoading(true)

            DocumentService.updateOrder(
                id!,
                false,
                moment(deliveryDate).format('YYYY-MM-DD'),
                text ? text : data?.comment + ' ' + comment,
                cart
            ).then((e) => {
                if(e.status === 'success'){
                    onSuccessNotify(e.message)
                } else {
                    onErrorNotify(e.message)
                }
                mutate().then(() => {
                    setLoading(false)
                })
                setComment('')

            })

        } catch(e) {
            console.log('[ERROR]',e)
        } finally {
            setOpenModal(false)
            closeEdit()
        }
    }

    const restoreCart = () => {
        const newCart: ICart[] = data?.items?.map((item) => {
            return {
              product: item.product, 
              quantity: item.quantity, 
              sku: item.sku,         
              price: item.product.price *  item.quantity
            };
        }) || [];
        setCart(newCart)
        onSuccessNotify('מוצרים התווספו לסל')
    }

    const handleOpenEdit = () => {
        clearCart()
        if(data){
            setChoosedDocument(data)
        }
        setOpenEdit(!openEdit)
        const newCart: ICart[] = data?.items?.map((item) => {
            return {
              product: item.product, 
              quantity: item.quantity, 
              sku: item.sku,    
              price: item.product.price,
            };
        }) || [];
        setCart(newCart)

    }

    const closeEdit = () => {
        setOpenEdit(false)
        setChoosedDocument(null)
        clearCart()
    }

    useEffect(() => {
        if(data?.deliveryDate){
            setDeliveryDate(new Date(data?.deliveryDate))
        }
    },[data])

    return (
        <Box>
            <Box sx={{mt:'20px', mb:'20px'}}>
                {data?.comment &&
                    <Typography sx={{color:'#154D72'}}>
                    הערה: {data?.comment}
                    </Typography>
                }
            </Box>
            {!isCanEdit ?
                <>
                {!isLoading &&
                <Button 
                    sx={{mt:'15px'}}
                    variant='contained' 
                    fullWidth
                    onClick={restoreCart}
                    endIcon={
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                            d="M2 10C2 10 4.00498 7.26822 5.63384 5.63824C7.26269 4.00827 9.5136 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.89691 21 4.43511 18.2543 3.35177 14.5M2 10V4M2 10H8"
                            stroke="#F5F7FA"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                        </svg>
                    }
                >
                    שחזור הזמנה
                </Button>
                }

                </>
            :
                <>
                {(!openEdit && !loading && !isLoading) &&
                    <Box sx={{display:'flex', gap:'10px'}}>
                        <Button 
                            variant='outlined' 
                            fullWidth
                            color='info'
                            onClick={() => setOpenModal(true)}
                            endIcon={
                                <svg
                                width="25"
                                height="26"
                                viewBox="0 0 25 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    d="M6.00014 16H19.1359C20.1487 16 20.6551 16 21.0582 15.8112C21.4134 15.6448 21.7118 15.3777 21.9163 15.0432C22.1485 14.6633 22.2044 14.16 22.3163 13.1534L22.9013 7.88835C22.9355 7.58088 22.9525 7.42715 22.9031 7.30816C22.8597 7.20366 22.7821 7.11697 22.683 7.06228C22.5702 7 22.4155 7 22.1062 7H5.50014M3 4H4.24844C4.51306 4 4.64537 4 4.74889 4.05032C4.84002 4.09463 4.91554 4.16557 4.96544 4.25376C5.02212 4.35394 5.03037 4.48599 5.04688 4.7501L5.95312 19.2499C5.96963 19.514 5.97788 19.6461 6.03456 19.7462C6.08446 19.8344 6.15998 19.9054 6.25111 19.9497C6.35463 20 6.48694 20 6.75156 20H20M8.5 23.5H8.51M17.5 23.5H17.51M9 23.5C9 23.7761 8.77614 24 8.5 24C8.22386 24 8 23.7761 8 23.5C8 23.2239 8.22386 23 8.5 23C8.77614 23 9 23.2239 9 23.5ZM18 23.5C18 23.7761 17.7761 24 17.5 24C17.2239 24 17 23.7761 17 23.5C17 23.2239 17.2239 23 17.5 23C17.7761 23 18 23.2239 18 23.5Z"
                                    stroke="#FF32BB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    style={{
                                    stroke: "#FF32BB",
                                    strokeOpacity: 1
                                    }}
                                />
                                <path
                                    d="M3 21L21.5 3"
                                    stroke="white"
                                    strokeWidth="6"
                                    strokeLinecap="round"
                                    style={{
                                    stroke: "white",
                                    strokeOpacity: 1
                                    }}
                                />
                                <path
                                    d="M2.5 21L21 3"
                                    stroke="#FF32BB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    style={{
                                    stroke: "#FF32BB",
                                    strokeOpacity: 1
                                    }}
                                />
                                </svg>
                            }
                        >
                        בטל הזמנה
                        </Button>
                        <Button 
                            variant='contained' 
                            fullWidth
                            onClick={() => handleOpenEdit()}
                            endIcon={
                                <img src={`${process.env.REACT_APP_MEDIA}/edit.svg`} width={'24px'} height={'24px'}/>
                            }
                        >
                        ערוך הזמנה
                        </Button>
                    </Box>
                }
   
                </>
            }
            {openEdit &&
                <Box>
                    <Box sx={{margin:'15px 0'}}>
                        <Typography color='#154D72' fontSize={'15px'} fontWeight={700}>
                        בחרו תאריך למשלוח
                        </Typography>
                        <Typography color='#154D72' fontSize={'15px'} fontWeight={400}>
                        בחרו תאריך מתוך התאריכים הזמינים
                        </Typography>
                    </Box>
                    <DemoContainer components={['DatePicker']}>
                        <DatePicker  value={moment(deliveryDate)} onChange={(e) => setDeliveryDate(new Date(e?.toString()!))}/>
                    </DemoContainer>
                    <TextField
                       multiline
                       variant="outlined"
                       placeholder='הוסיפו הערה...'
                       fullWidth
                       sx={{
                        mt:'20px'
                       }}
                       value={comment}
                       onChange={(e) => setComment(e.target.value)}
                   />
                    <Box sx={{display:'flex', gap:'10px', mt:'20px'}}>
                        <Button
                            fullWidth
                            variant='contained'
                            onClick={() => handleEdit()}
                        >
                        עדכן הזמנה
                        </Button>
                        <Button
                            fullWidth
                            variant='outlined'
                            color='info'
                            onClick={() => closeEdit()}
                        >
                        בטל עריכה 
                        </Button>
                    </Box>
                </Box>
            }

            <ModalWrapper 
                active={openModal} 
                setActive={setOpenModal}
                component={
                    <Typography color='#154D72' fontWeight={700} lineHeight={'28px'} fontSize={'20px'}>
                        לבטל את ההזמנה?
                    </Typography>
                }
            >
                <Box>
                    <Typography color='#436F7C' fontWeight={700} lineHeight={'22.5px'} fontSize={'15px'}>
                    שימו לב! 
                    </Typography>
                    <Typography fontSize={'15px'} fontWeight={400}color='#436F7C'>
                    בלחיצה על ״בטל הזמנה״ המידע שהוזן בהזמנה זו ימחק.
                    </Typography>
                    <Typography sx={{mt:'30px'}} color='#436F7C' fontWeight={700} lineHeight={'22.5px'} fontSize={'15px'}>
                    אנא ציינו את סיבת הביטול
                    </Typography>
                    <Typography fontSize={'15px'} fontWeight={400}color='#436F7C'>
                    הזינו לפחות 15 תווים
                    </Typography>
                    <TextField
                        sx={{
                            mt:'10px'
                        }}
                        placeholder='סיבת ביטול הזמנה'
                        fullWidth
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                    <Box>
                        <Button 
                            variant='outlined' 
                            fullWidth
                            color='info'
                            sx={{
                                mt:'20px'
                            }}
                            endIcon={
                                text.length < 15 
                                ? <MySvgIcon2/>
                                : <MySvgIcon1/>

                            }
                            disabled={text.length < 15}
                            onClick={handleDelete}
                        >
                        ביטול הזמנה
                        </Button>
                    </Box>
                    <Box>
                        <Button 
                            sx={{
                                mt:'20px'
                            }}
                            fullWidth
                            onClick={() => setOpenModal(false)}
                        >
                        חזרה לסיכום הזמנה
                        </Button>
                    </Box>
                </Box>
            </ModalWrapper>
        </Box>
    );
};

export default Options;